WB.Routing = WB.Routing || {};

WB.Routing.PathHelper = function ($route, $location, _User, LocationsDataManager) {

    var _this = this;

    // Returns a path for the current URL, with the modified params

    this.path = function (params) {
        // If there are no locals, that means it is still resolving
        if (!$route.current || !$route.current.locals) {
            return;
        }

        var targetName = $route.current.locals.name;

        //Took this out for SEO
        // When generating a path, if a location is passed in and the current route is
        // NOT a location route, then just generate a path for forecasts.
        //if (params['location'] && !$route.current.params['location']) {
        //    _this.pathForName(targetName, params);
        //}

        return _this.pathForName(targetName, params);
    };

    // Url helpers

    this.pathForName = function (name, params) {
        params = params || {};

        var route;
        for (var path in $route.routes) {
            if (!$route.routes[path].resolve) {
                continue;
            }
            if (name === $route.routes[path].resolve.name()) {
                route = {
                    path: path,
                    route: $route.routes[path]
                };
                break;
            }
        }

        if (!route) {
            throw Error('No route exists for [' + name + '].');
        }

        if (params['location']) {
            if (route.path.indexOf(':location') === -1) {
                var lastslash = route.path.lastIndexOf('/');
                if (lastslash != -1) {
                    if (route.path.indexOf(':id') > -1) {
                        if (route.path.indexOf('cameras/traffic') > -1 || route.path.indexOf('cameras/weather') > -1) {
                            var newpath = route.path.slice(0, lastslash + 1) + params['location'];
                            route.path = newpath;
                        }
                        else if (route.path.indexOf('photos') > -1 || route.path.indexOf('videos') > -1 || route.path.indexOf('media/stories')) {
                            route.path = route.path;
                        }
                    }
                    else if (route.path.indexOf('appdownload') > -1)
                    {
                        route.path = route.path;
                    }
                    else if (name === 'homepage') {
                        var newpath = 'weather-forecast/now/' + params['location'];
                        route.path = newpath;
                    }
                    else {
                        var newpath = route.path.slice(0, lastslash + 1) + params['location'] + route.path.slice(lastslash + 1);
                        route.path = newpath;
                    }
                }
            }
        }

        route.route.keys.forEach(function (key) {
            if (params[key.name]) {
                route.path = route.path.replaceMultiple([':' + key.name + '*', ':' + key.name], params[key.name]);
                delete params[key.name];
            } else if ($route.current && $route.current.params[key.name]) {
                route.path = route.path.replaceMultiple([':' + key.name + '*', ':' + key.name], $route.current.params[key.name]);
            }
        });

        var station = $location.search()['station'];
        if (typeof params['station'] !== 'undefined') {
            if (params['station']) {
                route.path += (route.path.indexOf('?') === -1 ? '?' : '&') + 'station' + '=' + params['station'];
            }
            delete params['station'];
        } else if (station) {
            route.path += (route.path.indexOf('?') === -1 ? '?' : '&') + 'station' + '=' + station;
        }


        // Add the leftover params to the query string

        for (var param in params) {
            if (params[param]) {
                if($route.current.locals.controller == 'weatherlandingcamera' && ($location.search()['cam'] && $location.search()['cam']!== '')  && param === 'cam'){
                    continue;
                }
                if($route.current.locals.controller == 'trafficlandingcamera' && ($location.search()['latlng'] && $location.search()['latlng']!== '')  && param === 'latlng'){
                    continue;
                }
                if(param == 'featuredCam'){
                    route.path += (route.path.indexOf('?') === -1 ? '?' : '&') + 'cam=' + params[param];
                    continue;
                }
                route.path += (route.path.indexOf('?') === -1 ? '?' : '&') + param + '=' + params[param];                
            }
        }

        //        Change location if in params


        // Finally, we need to ensure that the locations (locality and station) are properly set
        // for cases where the URL doesn't already include them (popups, for example)

        if (route.path.indexOf(':location') !== -1) {
            var targetLocation = _User.ActiveLocation,
                //locationStringReplace = targetLocation.Locality.RouteString; 
                locationStringReplace = '';

            // So, we have a location still. This means we need to massage the route path
            // to include the right location and station
            route.path = route.path.replaceMultiple([':location*', ':location'], locationStringReplace);

            if (LocationsDataManager.HasNonDefaultStation(targetLocation) && (route.path.indexOf('station=') === -1)) {
                route.path += (route.path.indexOf('?') === -1 ? '?' : '&') + 'station=' + targetLocation.Station.RouteString;
            }
        }

        route.path = route.path.replace(/weather-camera-[a-zA-Z\-]*/g,'weather-camera');
        return route.path;
    };

    // Returns the path for the location specified

    this.pathForLocation = function (location, source) {


        var params = angular.copy($location.search());
        params.location = location.Locality.RouteString;
        params.station = null;

        if (location.Station && (location.Station.RouteString !== location.DefaultStationRouteString)) {
            params.station = location.Station.RouteString;
        }

        return _this.path(params);
    };

    this.pathForNameAndLocation = function (name, location, params) {
        params = params || {};
        params.location = location.Locality.RouteString;
        params.station = null;

        if (location.Station && (location.Station.RouteString !== location.DefaultStationRouteString)) {
            params.station = location.Station.RouteString;
        }
        return this.pathForName(name, params);
    };

    this.pathForNameAndLocality = function (name, locality, params) {
        if (!locality) {
            return;
        }

        params = params || {};
        params.location = locality.RouteString;
        params.station = null;

        return this.pathForName(name, params);
    };

};
WB.Routing.PathHelper.$inject = ['$route', '$location', '_User', 'LocationsDataManager'];

WB.App.service('PathHelper', WB.Routing.PathHelper);
